import React, { useEffect, useRef, useState } from "react";

import { useInView } from "react-intersection-observer";
import { useResponsiveDimensions } from "../../lib/hooks/useResponsiveDimensions";

import infiniteLogoBg from "../../assets/images/infinite-logo-bg.png";
import productOnTable from "../../assets/images/product-on-table.jpg";
import productOne from "../../assets/images/product1.jpg";
import allProducts from "../../assets/images/all-products.jpeg";
import topImage from "../../assets/images/top-left-image.png";
import bottomImage from "../../assets/images/bottom-right-image.png";
import linesImage from "../../assets/images/lines.png";
import halfInfinite from "../../assets/images/half-infinite.png";
import completeInfinite from "../../assets/images/complete-infinite.png";
import doubleInfinite from "../../assets/images/double-infinite.png";
import flowerImage from "../../assets/images/flower.png";
import FlickitySlider from "../../components/FlickitySlider/FlickitySlider";
import productHardware from "../../assets/images/product-hardware.jpg";

import ProductsGroup from "../Products/ProductsGroup/ProductsGroup";

import cs from "classnames";

import "./Home.scss";

const Home = () => {
  const [sliderWidthValue, setSliderWidthValue] = useState<number>();
  const isMobile = useResponsiveDimensions().isMobile;
  const windowWidthValue = window.innerWidth;
  const { ref: infiniteBgRef, inView: infiniteBgVisibility } = useInView();
  const { ref: sloganRef, inView: sloganVisibility } = useInView();
  const { ref: productsTitleRef, inView: productsTitleVisible } = useInView();
  const { ref: flowerTitleRef, inView: flowerTitleVisibility } = useInView();
  const { ref: flowerImageRef, inView: flowerImageVisibility } = useInView();
  const { ref: flowerLeafOneRef, inView: flowerLeafOneVisibility } =
    useInView();
  const { ref: flowerLeafTwoRef, inView: flowerLeafTwoVisibility } =
    useInView();
  const { ref: flowerLeafThreeRef, inView: flowerLeafThreeVisibility } =
    useInView();
  const { ref: flowerLeafFourRef, inView: flowerLeafFourVisibility } =
    useInView();
  const { ref: threeCartsTitleRef, inView: threeCartsTitleVisibility } =
    useInView();

  const { ref: cartsRef, inView: cartsVisibility } = useInView();
  const { ref: cartOneRef, inView: cartOneVisibility } = useInView();
  const { ref: cartTwoRef, inView: cartTwoVisibility } = useInView();
  const { ref: cartThreeRef, inView: cartThreeVisibility } = useInView();
  const { ref: twoImagesTitleRef, inView: twoImagesTitleVisibility } =
    useInView();
  const { ref: twoImagesTopRef, inView: twoImagesTopVisibility } = useInView();
  const { ref: twoImagesBottomRef, inView: twoImagesBottomVisibility } =
    useInView();
  const { ref: allProductsRef, inView: allProductsVisibility } = useInView();
  const { ref: sliderTitleRef, inView: sliderTitleVisibility } = useInView();
  const { ref: sliderRef, inView: sliderVisibility } = useInView();
  const { ref: productOnTableImageRef, inView: productOnTableImageVisibility } =
    useInView();
  const { ref: productOnTableTitleRef, inView: productOnTableTitleVisibility } =
    useInView();
  const {
    ref: productOnTableSubTitleRef,
    inView: productOnTableSubTitleVisibility,
  } = useInView();

  useEffect(() => {
    if (!isMobile) {
      const marginLeftValue = (windowWidthValue - 1200) / 2;
      setSliderWidthValue(marginLeftValue + 1200);
    }
  }, [windowWidthValue]);

  return (
    <div className="Home">
      <div className="InfiniteLogoBg">
        <img
          ref={infiniteBgRef}
          loading="lazy"
          alt="Infinite Bg"
          className={cs(
            "InfiniteLogoBg__image",
            infiniteBgVisibility && "InfiniteLogoBg__image-animation",
          )}
          src={infiniteLogoBg}
        />
        <div
          ref={sloganRef}
          className={cs(
            "InfiniteLogoBg__text",
            sloganVisibility && "InfiniteLogoBg__text-animation",
          )}
        >
          Elevating Connectivity to <br />
          Infinite Heights
        </div>
      </div>

      <div id="Home__products" className="Home__products">
        <div
          ref={productsTitleRef}
          className={cs(
            "Home__products-title",
            productsTitleVisible && "Home__products-title-animation",
          )}
        >
          Explore Our Products
        </div>
        <ProductsGroup />
      </div>

      <div className="Flower">
        <div
          ref={flowerTitleRef}
          className={cs(
            "Flower__title",
            flowerTitleVisibility && "Flower__title-animation",
          )}
        >
          A Glimpse Into Our Services
        </div>
        <img
          ref={flowerImageRef}
          loading="lazy"
          className={cs(
            "Flower__image",
            flowerImageVisibility && "Flower__image-animation",
          )}
          src={flowerImage}
        />
        <div className="Flower__container">
          <div className="Flower__leaf"></div>
          <div className="Flower__leaf">
            <div
              ref={flowerLeafOneRef}
              className={cs(
                "Flower__leaf-text",
                flowerLeafOneVisibility && "Flower__leaf-text-leafOneAnimation",
              )}
            >
              Business <br /> <span>Solutions</span>
            </div>
          </div>
          <div className="Flower__leaf"></div>
          <div className="Flower__leaf">
            <div
              ref={flowerLeafTwoRef}
              className={cs(
                "Flower__leaf-text",
                flowerLeafTwoVisibility && "Flower__leaf-text-leafTwoAnimation",
              )}
            >
              5G <br /> <span>FWA</span>
            </div>
          </div>
          <div className="Flower__leaf"></div>
          <div className="Flower__leaf">
            {" "}
            <div
              ref={flowerLeafThreeRef}
              className={cs(
                "Flower__leaf-text",
                flowerLeafThreeVisibility &&
                  "Flower__leaf-text-leafThreeAnimation",
              )}
            >
              Wi-Fi 6 <br /> <span>Access Points</span>
            </div>
          </div>
          <div className="Flower__leaf"></div>
          <div className="Flower__leaf">
            {" "}
            <div
              ref={flowerLeafFourRef}
              className={cs(
                "Flower__leaf-text",
                flowerLeafFourVisibility &&
                  "Flower__leaf-text-leafFourAnimation",
              )}
            >
              Mesh <br /> <span>Systems</span>
            </div>
          </div>
          <div className="Flower__leaf"></div>
        </div>
      </div>

      <div className="ThreeCartsTitle">
        <div
          className={cs(
            "ThreeCartsTitle__text",
            threeCartsTitleVisibility && "ThreeCartsTitle__text-animation",
          )}
          ref={threeCartsTitleRef}
        >
          Unrivaled Connectivity and Innovation
        </div>
      </div>

      <div className="ThreeCarts">
        <div
          ref={cartsRef}
          className={cs(
            "ThreeCarts__carts",
            cartsVisibility && "ThreeCarts__carts-animation",
          )}
        >
          <div
            ref={cartOneRef}
            className={cs(
              "ThreeCarts__cart",
              cartOneVisibility && "ThreeCarts__cart-cartOneAnimation",
            )}
          >
            <img
              loading="lazy"
              src={halfInfinite}
              className="ThreeCarts__cart-icon1"
            />
            <div className="ThreeCarts__cart-title">
              Unmatched <br /> Reliability
            </div>
            <div className="ThreeCarts__cart-subtitle">
              Our devices are built to deliver consistent, high-speed
              connectivity without interruption, ensuring your business stays
              ahead.
            </div>
          </div>
          <div
            ref={cartTwoRef}
            className={cs(
              "ThreeCarts__cart",
              cartTwoVisibility && "ThreeCarts__cart-cartTwoAnimation",
            )}
          >
            <img
              loading="lazy"
              src={completeInfinite}
              className="ThreeCarts__cart-icon2"
            />
            <div className="ThreeCarts__cart-title">
              Exceptional <br /> Support
            </div>
            <div className="ThreeCarts__cart-subtitle">
              Infinite Technologies stands by your side, offering expert support
              and guidance to navigate the complexities of modern connectivity
              solutions.
            </div>
          </div>
          <div
            ref={cartThreeRef}
            className={cs(
              "ThreeCarts__cart",
              cartThreeVisibility && "ThreeCarts__cart-cartThreeAnimation",
            )}
          >
            <img
              loading="lazy"
              src={doubleInfinite}
              className="ThreeCarts__cart-icon3"
            />
            <div className="ThreeCarts__cart-title">
              Innovative <br /> Technology
            </div>
            <div className="ThreeCarts__cart-subtitle">
              We lead with innovation, crafting devices that redefine the
              standards of speed and efficiency for tomorrow's business needs.
            </div>
          </div>
        </div>

        <img loading="lazy" className="ThreeCarts__image" src={linesImage} />
      </div>

      <div className="TwoImages">
        <div className="TwoImages__container">
          <div
            ref={twoImagesTitleRef}
            className={cs(
              "TwoImages__title",
              twoImagesTitleVisibility && "TwoImages__title-animation",
            )}
          >
            Streamlining Operations with Unified Connectivity Solutions
          </div>
          <div
            ref={twoImagesTopRef}
            className={cs(
              "TwoImages__top",
              twoImagesTopVisibility && "TwoImages__top-animation",
            )}
          >
            <img
              loading="lazy"
              className="TwoImages__top-image"
              src={productOnTable}
            />
            <div className="TwoImages__top-text">
              <div className="TwoImages__top-text-one">
                Centralize Your Connectivity, Simplify Your Operation
              </div>
              <div className="TwoImages__top-text-two">
                Our intuitive platform brings the power of Infinite Technologies
                into the palm of your hand, offering seamless control over your
                entire network with just a few taps
              </div>
            </div>
          </div>
          <div
            ref={twoImagesBottomRef}
            className={cs(
              "TwoImages__bottom",
              twoImagesBottomVisibility && "TwoImages__bottom-animation",
            )}
          >
            <div className="TwoImages__bottom-text">
              <div className="TwoImages__bottom-text-one">
                Beyond Hardware, Unified Ecosystem
              </div>
              <div className="TwoImages__bottom-text-two">
                Experience the synergy of cutting-edge hardware and
                sophisticated software, designed to offer a cohesive,
                user-friendly connectivity experience
              </div>
            </div>
            <img
              loading="lazy"
              className="TwoImages__bottom-image"
              src={productHardware}
            />
          </div>
        </div>
      </div>

      <div className="AllProducts">
        <img
          ref={allProductsRef}
          loading="lazy"
          className={cs(
            "AllProducts__image",
            allProductsVisibility && "AllProducts__image-animation",
          )}
          src={allProducts}
        />
      </div>

      {/*<div className="Slider">*/}
      {/*  <div*/}
      {/*    className="Slider__title-container"*/}
      {/*    style={{ maxWidth: `${sliderWidthValue}px` }}*/}
      {/*  >*/}
      {/*    <div*/}
      {/*      ref={sliderTitleRef}*/}
      {/*      className={cs(*/}
      {/*        "Slider__title",*/}
      {/*        sliderTitleVisibility && "Slider__title-animation",*/}
      {/*      )}*/}
      {/*    >*/}
      {/*      <span>Lorem ipsum</span> dollor with the latest technology*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div*/}
      {/*    ref={sliderRef}*/}
      {/*    className={cs(*/}
      {/*      "Slider__container",*/}
      {/*      sliderVisibility && "Slider__container-animation",*/}
      {/*    )}*/}
      {/*    style={{ maxWidth: `${sliderWidthValue}px` }}*/}
      {/*  >*/}
      {/*    <FlickitySlider*/}
      {/*      options={{*/}
      {/*        lazyLoad: 10,*/}
      {/*        contain: true,*/}
      {/*        draggable: true,*/}
      {/*        prevNextButtons: false,*/}
      {/*        cellAlign: "center",*/}
      {/*        freeScroll: true,*/}
      {/*        freeScrollFriction: 0.03,*/}
      {/*        imagesLoaded: true,*/}
      {/*        pageDots: isMobile,*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <div className="Slider__item">*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productOne}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Design <br /> <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*      <div className="Slider__item">*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productTwo}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Router and Satellite <br />*/}
      {/*          <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*      <div className={cs("Slider__item", "Slider__item-three")}>*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productOne}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Design <br /> <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>{" "}*/}
      {/*      <div className="Slider__item">*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productTwo}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Design <br /> <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>{" "}*/}
      {/*      <div className="Slider__item">*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productOne}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Design <br /> <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>{" "}*/}
      {/*      <div className="Slider__item">*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productTwo}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Design <br /> <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>{" "}*/}
      {/*      <div className="Slider__item">*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productOne}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Design <br /> <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>{" "}*/}
      {/*      <div className="Slider__item">*/}
      {/*        <img*/}
      {/*          className="Slider__item-image"*/}
      {/*          data-flickity-lazyload={productTwo}*/}
      {/*        />*/}
      {/*        <div className="Slider__item-title">*/}
      {/*          Design <br /> <span>Experience a blazing-fast performance</span>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </FlickitySlider>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*<div className="ProductOnTable">*/}
      {/*  <img*/}
      {/*    ref={productOnTableImageRef}*/}
      {/*    loading="lazy"*/}
      {/*    alt="Infinite Bg"*/}
      {/*    className={cs(*/}
      {/*      "ProductOnTable__image",*/}
      {/*      productOnTableImageVisibility && "ProductOnTable__image-animation",*/}
      {/*    )}*/}
      {/*    src={productOnTable}*/}
      {/*  />*/}
      {/*  <div className="ProductOnTable__text">*/}
      {/*    <div*/}
      {/*      ref={productOnTableTitleRef}*/}
      {/*      className={cs(*/}
      {/*        "ProductOnTable__text-title",*/}
      {/*        productOnTableTitleVisibility &&*/}
      {/*          "ProductOnTable__text-title-animation",*/}
      {/*      )}*/}
      {/*    >*/}
      {/*      Infinite Possibilities with wide range of products*/}
      {/*    </div>*/}
      {/*    <div*/}
      {/*      ref={productOnTableSubTitleRef}*/}
      {/*      className={cs(*/}
      {/*        "ProductOnTable__text-subtitle",*/}
      {/*        productOnTableSubTitleVisibility &&*/}
      {/*          "ProductOnTable__text-subtitle-animation",*/}
      {/*      )}*/}
      {/*    >*/}
      {/*      Experience a blazing-fast performance with ultra-high speed.*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default Home;
